var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "netgsm-channel-detail" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: {
          paths: [{ title: _vm.$t("whatsappChannel.netgsmDetail") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "IconButton",
                {
                  attrs: {
                    "on-click": function () {
                      return _vm.$router.push("/integrations/sms/netgsm")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" chevron_left "),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [_vm._v("Netgsm")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "channel-content" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c("ChannelMenu", {
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.channel
            ? _c("div", { staticClass: "page-content" }, [
                _vm.currentTab === _vm.NetgsmChannelMenuTypes.CHANNEL.id
                  ? _c(
                      "div",
                      [
                        _c("UpdateDetail", {
                          attrs: { credit: _vm.credit },
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.NetgsmChannelMenuTypes.SEND_SMS.id
                  ? _c(
                      "div",
                      [
                        _c("SendSmsNetgsm", {
                          attrs: {
                            channel: _vm.channel,
                            senders: _vm.senders,
                            credit: _vm.credit,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-container" }, [
      _c("img", { attrs: { src: "/static/img/netgsm-logo.svg" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }